import {TMediaEntry} from '@chancer/common/lib/interfaces/firestore/FirestoreInterfaces';
import {getIsImage, getIsVideo} from '@chancer/common/lib/utils/MediaUtils';
import React from 'react';

interface IProps {
  media: TMediaEntry;
}

export const MediaView: React.FC<IProps> = (props) => {
  return getIsImage(props.media) ? (
    <img
      style={{
        width: '100%',
        height: '100%',
        border: 0,
        overflow: 'hidden',
        objectFit: 'contain',
      }}
      src={props.media.image.url}
      alt=""
    />
  ) : getIsVideo(props.media) ? (
    <video
      key={props.media.video.url}
      style={{
        width: '100%',
        height: '100%',
        border: 0,
        overflow: 'hidden',
        objectFit: 'contain',
      }}
      id="myVideo"
      className="screen_container__background--video"
      playsInline
      loop
      autoPlay
      muted>
      <source src={props.media.video.url} type="video/mp4" />
    </video>
  ) : null;
};
